var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightSwitchOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 0H64C28.625 0 0 28.625 0 64V448C0 483.375 28.625 512 64 512H320C355.375 512 384 483.375 384 448V64C384 28.625 355.375 0 320 0ZM192 32C200.875 32 208 39.125 208 48S200.875 64 192 64S176 56.875 176 48S183.125 32 192 32ZM192 480C183.125 480 176 472.875 176 464S183.125 448 192 448S208 455.125 208 464S200.875 480 192 480ZM288 288V368C288 394.5 266.5 416 240 416H144C117.5 416 96 394.5 96 368V144C96 117.5 117.5 96 144 96H240C266.5 96 288 117.5 288 144V288ZM128 352C128 369.625 142.375 384 160 384H224C241.625 384 256 369.625 256 352V256H128V352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSwitchOff);
export default __webpack_public_path__ + "static/media/light-switch-off.76d4f9425f2f1fff1f266d421b0df829.svg";
export { ForwardRef as ReactComponent };